module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CLAN_URBAN_STYLE.a5151a17.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CLAN_URBAN_STYLE.png
// module id = 1143
// module chunks = 16